import { useDispatch, useSelector } from 'react-redux'
import { I18n, Translate } from 'react-redux-i18n'
import { Element } from '../../common/html/element'
import { Icon } from '../../common/html/icon'
import { STATUS_MESS } from '../constants'
import {
  changeShowHistoryList,
  createNewTopic,
  selectStatusMess,
  selectTopicActive,
} from '../store/slice'

const FooterChatbot = ({
  question,
  setQuestion,
  questionReply,
  setQuestionReply,
  sendUserMessage,
  messageInputRef,
}) => {
  const dispatch = useDispatch()

  const statusMess = useSelector(selectStatusMess)
  const topicActive = useSelector(selectTopicActive)

  const toggleSessionHistory = () => {
    dispatch(changeShowHistoryList(true))
  }

  const handleSend = () => {
    if (!question) return
    const trimmed = question?.trim()
    const hasAsk = Boolean(questionReply?.trim())
    if (
      !trimmed &&
      statusMess !== STATUS_MESS.PENDING &&
      statusMess !== STATUS_MESS.PROCESSING
    )
      return
    sendUserMessage(trimmed, hasAsk ? questionReply : undefined)
  }

  const handleCreateNewTopic = () => {
    dispatch(createNewTopic())
  }

  return (
    <div className="chatbot-footer">
      <div className="footer-nav">
        <div
          className={`nav-item ${
            topicActive?.topicId ? 'nav-item-new' : 'nav-item-new-disable'
          }`}
          onClick={handleCreateNewTopic}
        >
          <Icon className="icon-plus-circle-fill" style={{ fontSize: 14 }} />
          <Element style={{ fontSize: 14 }}>
            <Translate value="chatbot.NEW_CHAT" />
          </Element>
        </div>
        <div className="nav-divider"></div>
        <div
          className="nav-item nav-item-history"
          onClick={toggleSessionHistory}
        >
          <Icon className="icon-history" style={{ fontSize: 14 }} />
          <Element style={{ fontSize: 14 }}>
            <Translate value="chatbot.SESSION_HISTORY" />
          </Element>
        </div>
      </div>

      <div className="chat-input-container dFlex">
        <div className="w100">
          {questionReply && (
            <Element className="chat-ask">
              <Element className="chat-ask-text">
                <Icon
                  className="icon-reply"
                  style={{ fontSize: 20, color: '#9C9C9C' }}
                />
                <Element className="chat-ask-content" style={{ fontSize: 14 }}>
                  "{questionReply}"
                </Element>
              </Element>
              <Icon
                className="icon-delete-circle-outline icon"
                style={{ fontSize: 14 }}
                onClick={() => setQuestionReply('')}
              />
            </Element>
          )}
          <Element
            elementName="textarea"
            placeholder={I18n.t('chatbot.PLACEHOLDER_ASK')}
            className="message-input"
            rows="3"
            style={{
              resize: 'none',
              fontSize: 14,
              width: '100%',
            }}
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            ref={messageInputRef}
            autoFocus
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault()
                handleSend()
              }
            }}
          />
        </div>
        <div className="dFlex justifyContentEnd alignItemsEnd">
          <Element
            className={`send-btn ${
              question.trim() &&
              statusMess !== STATUS_MESS.PENDING &&
              statusMess !== STATUS_MESS.PROCESSING
                ? 'active'
                : ''
            }`}
            onClick={handleSend}
          >
            <div className="icon-send" style={{ fontSize: 16 }} />
          </Element>
        </div>
      </div>
    </div>
  )
}

export default FooterChatbot
